import { ReactNode } from 'react';
import { Tile } from 'components/Layout/PageContainer';
import { AttributeDisplayDescriptor, CoreEntity, ListAttributeDisplayDescriptor } from 'pages/entities/entities';
import { FormattedMessage } from 'react-intl';
import { AttributeBox } from 'pages/entities/components/AttributeBox';
import { LaidOutAttributeBoxes } from 'pages/entities/components/LayedOutAttributeBoxes';
import { AttributeRow } from 'pages/entities/components/AttributeRow';

export interface EntityHeaderProps {
  imageElement?: ReactNode;
  entity: CoreEntity;
  entityDisplayName: ReactNode;
  boxedAttributes?: AttributeDisplayDescriptor[];
  rowAttributes?: ListAttributeDisplayDescriptor[];
  custom?: ReactNode;
}

export function EntityHeader({
  imageElement = undefined,
  entity,
  entityDisplayName,
  boxedAttributes = [],
  rowAttributes = [],
  custom = undefined,
}: EntityHeaderProps) {
  const boxes = boxedAttributes.map(attributeDetails => (
    <AttributeBox
      key={attributeDetails.attributeCode}
      attributeCode={attributeDetails.attributeCode}
      attributeValue={attributeDetails.attributeValue}
      label={attributeDetails.label}
      useRaw={attributeDetails.useRaw}
      link={attributeDetails.link}
    />
  ));

  return (
    <Tile className="space-y-4" testId="product-detail-info">
      <div className="flex items-center">
        {imageElement && <div className="h-[130px] w-[130px] shrink:0">{imageElement}</div>}
        <div className="flex-1 ml-4 flex flex-col gap-2">
          <div>
            <div className="text-sm">
              <FormattedMessage id={`entities.name.singular.${entity}`} />
            </div>
            <div className="font-bold text-2xl">{entityDisplayName}</div>
          </div>
          {boxes.length > 0 && <LaidOutAttributeBoxes items={boxes} />}
          {rowAttributes.length > 0 &&
            rowAttributes.map(attributeDetails => (
              <AttributeRow
                key={attributeDetails.attributeCode}
                attributeCode={attributeDetails.attributeCode}
                labelId={attributeDetails.labelId}
                attributeValues={attributeDetails.attributeValues}
              />
            ))}
          {custom}
        </div>
      </div>
    </Tile>
  );
}
